// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as PlaceOrderMapHelper from "../../../app/helper/PlaceOrderMapHelper.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as MobileNumberValidation from "../../../../../../library/work-space/form/MobileNumberValidation.bs.js";

function addressPolygonValidation(addressValidation) {
  return PlaceOrderMapHelper.isCoordsUnderPolygon(addressValidation.locationBounds, addressValidation.latLng);
}

var validators_senderPhone = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      var senderPhone = param.senderPhone;
      if (senderPhone === "") {
        return {
                TAG: /* Error */1,
                _0: "Caller number is required"
              };
      }
      var value = MobileNumberValidation.execute(senderPhone, metadata.country);
      if (value.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: value._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Invalid caller number"
              };
      }
    })
};

var validators_senderName = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var senderName = param.senderName;
      var match = senderName.length;
      if (match !== 0) {
        return {
                TAG: /* Ok */0,
                _0: senderName
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Can't be empty"
              };
      }
    })
};

var validators_addressLineOne = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      var addressLineOne = param.addressLineOne;
      var match = addressLineOne.length;
      if (match !== 0) {
        if (addressPolygonValidation(metadata.addressValidation)) {
          return {
                  TAG: /* Ok */0,
                  _0: addressLineOne
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Location Not Found"
                };
        }
      } else {
        return {
                TAG: /* Error */1,
                _0: "Can't be empty"
              };
      }
    })
};

var validators = {
  senderPhone: validators_senderPhone,
  senderName: validators_senderName,
  addressLineTwo: undefined,
  addressLineOne: validators_addressLineOne
};

function initialFieldsStatuses(_input) {
  return {
          senderPhone: /* Pristine */0,
          senderName: /* Pristine */0,
          addressLineTwo: /* Pristine */0,
          addressLineOne: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            senderPhone: /* Pristine */0,
            senderName: /* Pristine */0,
            addressLineTwo: /* Pristine */0,
            addressLineOne: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.senderPhone;
  var match_0 = match ? match._0 : Curry._2(validators.senderPhone.validate, input, metadata);
  var match$1 = fieldsStatuses.senderName;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.senderName.validate, input, metadata);
  var match_0$2 = {
    TAG: /* Ok */0,
    _0: input.addressLineTwo
  };
  var match$2 = fieldsStatuses.addressLineOne;
  var match_0$3 = match$2 ? match$2._0 : Curry._2(validators.addressLineOne.validate, input, metadata);
  var senderPhoneResult = match_0;
  var senderPhoneResult$1;
  if (senderPhoneResult.TAG === /* Ok */0) {
    var senderNameResult = match_0$1;
    if (senderNameResult.TAG === /* Ok */0) {
      var addressLineTwoResult = match_0$2;
      if (addressLineTwoResult.TAG === /* Ok */0) {
        var addressLineOneResult = match_0$3;
        if (addressLineOneResult.TAG === /* Ok */0) {
          return {
                  TAG: /* Valid */0,
                  output: {
                    addressLineOne: addressLineOneResult._0,
                    addressLineTwo: addressLineTwoResult._0,
                    senderName: senderNameResult._0,
                    senderPhone: senderPhoneResult._0
                  },
                  fieldsStatuses: {
                    senderPhone: /* Dirty */{
                      _0: senderPhoneResult,
                      _1: /* Shown */0
                    },
                    senderName: /* Dirty */{
                      _0: senderNameResult,
                      _1: /* Shown */0
                    },
                    addressLineTwo: /* Dirty */{
                      _0: addressLineTwoResult,
                      _1: /* Hidden */1
                    },
                    addressLineOne: /* Dirty */{
                      _0: addressLineOneResult,
                      _1: /* Shown */0
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        senderPhoneResult$1 = senderPhoneResult;
      } else {
        senderPhoneResult$1 = senderPhoneResult;
      }
    } else {
      senderPhoneResult$1 = senderPhoneResult;
    }
  } else {
    senderPhoneResult$1 = senderPhoneResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            senderPhone: /* Dirty */{
              _0: senderPhoneResult$1,
              _1: /* Shown */0
            },
            senderName: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            addressLineTwo: /* Dirty */{
              _0: match_0$2,
              _1: /* Hidden */1
            },
            addressLineOne: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurSenderPhoneField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.senderPhone, validators_senderPhone, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  senderPhone: status,
                                  senderName: init.senderName,
                                  addressLineTwo: init.addressLineTwo,
                                  addressLineOne: init.addressLineOne
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSenderNameField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.senderName, validators_senderName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  senderPhone: init.senderPhone,
                                  senderName: status,
                                  addressLineTwo: init.addressLineTwo,
                                  addressLineOne: init.addressLineOne
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAddressLineTwoField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.addressLineTwo, state.fieldsStatuses.addressLineTwo, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  senderPhone: init.senderPhone,
                                  senderName: init.senderName,
                                  addressLineTwo: status,
                                  addressLineOne: init.addressLineOne
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAddressLineOneField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.addressLineOne, validators_addressLineOne, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  senderPhone: init.senderPhone,
                                  senderName: init.senderName,
                                  addressLineTwo: init.addressLineTwo,
                                  addressLineOne: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */4,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */5,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */7);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */6);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateSenderPhoneField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.senderPhone, state.submissionStatus, validators_senderPhone, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            senderPhone: status,
                                            senderName: init.senderName,
                                            addressLineTwo: init.addressLineTwo,
                                            addressLineOne: init.addressLineOne
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSenderNameField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.senderName, state.submissionStatus, validators_senderName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            senderPhone: init.senderPhone,
                                            senderName: status,
                                            addressLineTwo: init.addressLineTwo,
                                            addressLineOne: init.addressLineOne
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAddressLineTwoField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.addressLineTwo, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            senderPhone: init.senderPhone,
                                            senderName: init.senderName,
                                            addressLineTwo: status,
                                            addressLineOne: init.addressLineOne
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAddressLineOneField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.addressLineOne, state.submissionStatus, validators_addressLineOne, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            senderPhone: init.senderPhone,
                                            senderName: init.senderName,
                                            addressLineTwo: init.addressLineTwo,
                                            addressLineOne: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */4 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                senderPhone: /* Pristine */0,
                                senderName: /* Pristine */0,
                                addressLineTwo: /* Pristine */0,
                                addressLineOne: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                senderPhone: /* Pristine */0,
                                senderName: /* Pristine */0,
                                addressLineTwo: /* Pristine */0,
                                addressLineOne: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */5 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */6 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateSenderPhone: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSenderPhoneField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSenderName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSenderNameField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAddressLineTwo: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAddressLineTwoField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAddressLineOne: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAddressLineOneField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurSenderPhone: (function (param) {
              return Curry._1(dispatch, /* BlurSenderPhoneField */0);
            }),
          blurSenderName: (function (param) {
              return Curry._1(dispatch, /* BlurSenderNameField */1);
            }),
          blurAddressLineTwo: (function (param) {
              return Curry._1(dispatch, /* BlurAddressLineTwoField */2);
            }),
          blurAddressLineOne: (function (param) {
              return Curry._1(dispatch, /* BlurAddressLineOneField */3);
            }),
          senderPhoneResult: Formality.exposeFieldResult(state.fieldsStatuses.senderPhone),
          senderNameResult: Formality.exposeFieldResult(state.fieldsStatuses.senderName),
          addressLineTwoResult: Formality.exposeFieldResult(state.fieldsStatuses.addressLineTwo),
          addressLineOneResult: Formality.exposeFieldResult(state.fieldsStatuses.addressLineOne),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.senderPhone || match.senderName || match.addressLineTwo || match.addressLineOne) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */6,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */7);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var initialInput = {
  addressLineOne: "",
  addressLineTwo: "",
  senderName: "",
  senderPhone: ""
};

export {
  addressPolygonValidation ,
  Form ,
  initialInput ,
  
}
/* react Not a pure module */
